import { isAxiosError } from 'axios'
import { t } from 'i18next'

export const getCheckingAccountErrorMessage = (error: unknown) => {
  if (!error) return null

  if (isAxiosError(error)) {
    const messages = error.response?.data as { messages?: string[] } | undefined
    return messages?.messages?.[0] ?? t('common:messages.errorOccurred.message')
  }

  return t('common:messages.errorOccurred.message')
}
